export const SHOW_LOADER = "showLoader";
export const SHOW_SNACKBAR_MESSAGE = "showSnackbarMessage";
export const SET_AZURE_AD_USER_DETAIL = "setAzureAdUserDetail";
export const HIGHLIGHT_BUDGET_ALLOCATION_DETAIL =
	"highlightBudgetAllocationDetail";
export const HIGHLIGHT_DEPT_ALLOCATION_DETAIL =
	"highlightDepartmentAllocationDetail";
export const OPEN_BUDGET_ALLOCATION_STEP_HISTORY_DETAIL =
	"openBudgetAllocationStepHistoryDetail";
export const IS_STEP_ASSIGNED_TO_USER = "isStepAssignedToUser";
export const SHOW_HIDE_BUDGET_ALLOCATION_SIDEBAR =
	"showHideBudgetAllocationSidebar";
export const SHOW_BUDGET_ALLOCATION_HISTORY_ICON =
	"showBudgetAllocationHistoryIcon";
export const SHOW_SUPPLIER_DOCUMENT_HISTORY_ICON =
	"showSupplierDocumentHistoryIcon";
export const SHOW_WORKFLOW_HISTORY_ICON = "showWorkFlowHistoryIcon";
export const UPDATE_REQUISITION_LINE_PROC_METHOD =
	"updateRequisitionLineProcurementMethod";
export const OPEN_REQUISITION_STEP_HISTORY_DETAIL =
	"openRequisitionStepHistoryDetail";
export const IS_REQUISITION_ASSIGNED_TO_USER = "isRequisitionAssignedToUser";
export const IS_COREQUEST_ASSIGNED_TO_USER = "isCORequestAssignedToUser";
export const SET_UPDATED_REQUISITION_ITEM_LIST =
	"setUpdatedRequisitionItemList";
export const SET_REQUISITION_SELECTION_ITEM_GRID_LIST =
	"setRequisitionSelectionItemGridList";
export const SET_ALLOCATION_HISTORY_ICON_STYLE =
	"setAllocationHistoryIconStyle";
export const SET_SUPPLIER_DOC_HISTORY_ICON_STYLE =
	"setSupplierDocUploadHistoryIconStyle";
export const OPEN_SESSION_EXPIRE_DIALOG = "showSessionExpireDialog";
export const RESET_REQ_LINE_DETAIL_LIST = "resetRequisitionLineDetailList";
export const RESET_COR_LINE_DETAIL_LIST = "resetCORequestLineDetailList";
export const OPEN_BID_STEP_HISTORY_DETAIL = "openBidStepHistoryDetail";
export const SHOW_BID_HISTORY_ICON = "showBidHistoryIcon";
export const IS_CONTRACT_ASSIGNED_TO_USER = "isContractAssignedToUser";
export const SHOW_CONTRACT_HISTORY_ICON = "showContractHistoryIcon";
export const OPEN_CONTRACT_STEP_HISTORY_DETAIL =
	"openContractStepHistoryDetail";
export const EXTRACT_SUPPLIER_DOCUMENT = "extractSUpplierDocument";
export const RESET_CONTRACT_LINE_DETAIL_LIST = "resetContractLineDetailList";
export const SAVE_UPDATE_SUPPLIER_BID = "saveUpdateSupplierBid";
export const GET_ITEM_DETAIL_ON_PO_LINE = "getItemDetailOnPoLine";
export const SAVE_PERFORMANCE_EVALUATION_DETAIL =
	"savePerformanceEvaluationDetail";
export const SAVE_CONTRACT_DETAILS = "saveContractDetails";
export const IS_ITEM_ASSIGNED_TO_USER = "isItemAssignedToUser";
export const OPEN_ITEM_STEP_HISTORY_DETAIL = "openItemStepHistoryDetail";
export const SHOW_ITEM_WORKFLOW_HISTORY_ICON = "showItemWorkFlowHistoryIcon";
export const IS_BID_ASSIGNED_TO_USER = "isBidAssignedToUser";
export const SHOW_COREQUEST_WORKFLOW_HISTORY_ICON =
	"showCORequestWorkFlowHistoryIcon";
export const OPEN_COREQUEST_STEP_HISTORY_DETAIL =
	"openCORequestStepHistoryDetail";
export const BUYER_ASSIGNMENT_CHANGED = "buyerAssignmentChanged";
export const VALIDATE_BUYER = "validateBuyer";
